/*
 * @author        david.loehr@zumper.com
 * @copyright     Copyright (c) 2024, Zumper
 */

import { typeRegistry } from './reviveBizos'

export const __typename = 'SerializableDate'
const ISO8601 = '_'

export interface RawSerializableDate {
  readonly __typename: typeof __typename
  readonly [ISO8601]: string
}

type DateConstructorParams =
  | []
  | [rawSerializableDate: RawSerializableDate]
  | [value: string | number | Date]
  | [
      year: number,
      monthIndex: number,
      date?: number | undefined,
      hours?: number | undefined,
      minutes?: number | undefined,
      seconds?: number | undefined,
      ms?: number | undefined,
    ]

function isRawSerializableDate(
  params: DateConstructorParams
): params is [rawSerializableDate: RawSerializableDate] {
  return (
    params.length === 1 &&
    typeof params[0] === 'object' &&
    !!params[0] &&
    '__typename' in params[0] &&
    params[0].__typename === __typename
  )
}

export class SerializableDate extends Date {
  constructor(...params: DateConstructorParams) {
    switch (params.length) {
      case 0:
        super()
        break
      case 1:
        super(isRawSerializableDate(params) ? params[0][ISO8601] : params[0])
        break
      default:
        super(...params)
    }
  }

  // @ts-expect-error super.toJSON() returns a string, this toJSON() doesn't
  toJSON() {
    return {
      __typename,
      [ISO8601]: super.toISOString(),
    } as const
  }
}

typeRegistry.add(__typename, SerializableDate)
